import { render, staticRenderFns } from "./yigeUnitKanBan.vue?vue&type=template&id=33fcb07e&scoped=true&"
import script from "./yigeUnitKanBan.vue?vue&type=script&lang=js&"
export * from "./yigeUnitKanBan.vue?vue&type=script&lang=js&"
import style0 from "./yigeUnitKanBan.vue?vue&type=style&index=0&id=33fcb07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fcb07e",
  null
  
)

export default component.exports